import { createContext } from 'react';
import { DEFAULT_DAPP_STATE, DEFAULT_CHAIN } from '../constants';
import { ConnectionState } from '../../wallet/types';
export const DAppStateContext = createContext({
    isInitingStatus: () => false,
    isWalletModalOpen: false,
    setIsWalletModalOpen: () => { },
    installedWallets: [],
    walletConnection: {},
    setWalletConnection: () => { },
    ConnectionState,
    handleDisconnect: () => { },
    switchNetwork: () => { },
    switchableNetwork: [],
    state: DEFAULT_DAPP_STATE,
    activeState: DEFAULT_DAPP_STATE[DEFAULT_CHAIN],
    favoriteNFTs: [],
    toggleFavoriteNFT: () => { },
    mintNFTs: () => { },
    buyNFTs: () => { },
    listNFTs: () => { },
    delistNFTs: () => { },
    updateNFTPrices: () => { },
    withdrawMyProceeds: () => { },
    trackTransaction: () => { },
    connectWalletWithSign: async () => { },
    isWalletAuthenticated: false,
    isWalletSigningIn: false,
    txHistory: {},
    txHistoryStatus: 'idle',
    initSvmGlobalState: async () => { },
    updateSvmAuthority: async () => { },
    updateSvmPresalePrice: async () => { },
    updateSvmPriceFeed: async () => { },
    withdrawSvmIncome: async () => { },
    refreshSvmGlobalState: async () => { },
    transferEvmOwnership: async () => { },
    acceptEvmOwnership: async () => { },
    openEvmMarket: async () => { },
    closeEvmMarket: async () => { },
    scheduleEvmMintPriceChange: async () => { },
    applyEvmMintPriceChange: async () => { },
    cancelEvmMintPriceChange: async () => { },
    setEvmMarketFee: async () => { },
    withdrawEvmMarketFee: async () => { },
    withdrawEvmNftFee: async () => { },
    setEvmDefaultBatchSize: async () => { },
    setEvmWhitelistBatchSize: async () => { },
    setEvmMaxRoyaltyBps: async () => { },
    pauseEvmMinting: async () => { },
    unpauseEvmMinting: async () => { },
    setEvmWhitelisted: async () => { },
    refreshEvmGlobalState: async () => { },
});
